module.exports = __webpack_public_path__ + "resources/images/default_image-3b7e72b6916517485c4c39fa675ac8e2-cache.png";